<template>
  <div class="row mt-5">
    <div class="col-12 flex justify-end">
      <vs-button
        class="mr-5"
        data-cy="cancel"
        @click="back"
        color="primary"
        :disabled="saving || disabled"
      >
        Cancelar
      </vs-button>
      <vs-button
        data-cy="save-draft"
        class="mr-5 btn btn-secondary"
        @click="saveDraft"
        v-has-permission="'ED276'"
        :disabled="saving || disabled"
      >
        Guardar borrador
        <span v-show="saving" class="spinner-border spinner-border-sm text-primary" />
      </vs-button>
      <vs-button
        class="mr-5"
        data-cy="preview"
        @click="preview"
        color="warning"
        :disabled="saving || disabled"
      >
        Previsualizar
        <span v-show="saving" class="spinner-border spinner-border-sm text-primary" />
      </vs-button>
      <vs-button
        data-cy="save"
        @click="save"
        color="success"
        :disabled="saving || disabled"
      >
        Crear
        <span v-show="saving" class="spinner-border spinner-border-sm text-primary" />
      </vs-button>
    </div>
  </div>
</template>

<script>
import {BButton} from "bootstrap-vue";

export default {
  name: 'form-buttons',
  components: {BButton},
  props: {
    saving: Boolean,
    disabled: { type: Boolean, default: false },
    preview: Function,
    back: Function,
    save: Function,
    saveDraft: Function,
  },
};
</script>
